import request from '@/utils/requestInfoFD'
import { infoFDUrl } from './config'

type dataType = any

export default {
  // 获取头条新闻
  getHotHeadlines(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fdzq-news-center/api/1/client/user/news/hotHeadlines`,
      method: 'get',
      params: data.data,
      headers: {
        ...data.headers,
      },
      sign: true
    })
  },

  // 获取资讯信息流（自选 / 要闻 / IPO / 加密货币 共用）
  // specialType: 2=要闻, 3=自选全部, 4=自选财报, 5=自选公告, 6=IPO新股信息流, 7=加密货币, 9=评级
  // specialCode: 要闻=YW, 自选=ZX, IPO=IPO, 加密货币=JMHB
  
  getCatNews(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fdzq-news-center/api/1/client/user/news/catNews`,
      method: 'post',
      data: data.data,
      headers: {
        'Content-Type': 'application/json',
        ...data.headers,
      },
      sign: true
    })
  },

  // 获取智研专题列表
  getZhiYan(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fdzq-news-center/api/1/client/user/news/zhiYan`,
      method: 'get',
      params: data.data,
      headers: {
        ...data.headers,
      },
      sign: true
    })
  },

  //获取资讯7*24频道
  discoverNews(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fdzq-news-center/api/1/client/user/news/discoverNews`,
      method: 'post',
      data: data.data,
      headers: {
        'Content-Type': 'application/json',
        ...data.headers,
      },
      sign: true
    })
  },

  // 获取文章详情（自选/要闻/7*24 通用）
  // Body: { newsId: string, code?: string }
  getNewsDetail(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fdzq-news-center/api/1/client/user/news/detail`,
      method: 'post',
      data: data.data,
      headers: {
        'Content-Type': 'application/json',
        ...data.headers,
      }
    })
  },

  // 获取推荐资讯列表
  // Body: { newsId: number }
  getRecommendDetail(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fdzq-news-center/api/1/client/user/news/recommend/detail`,
      method: 'post',
      data: data.data,
      headers: {
        'Content-Type': 'application/json',
        ...data.headers,
      },
      sign: true
    })
  },

  // 广告列表-page分页查询-新客户端
  // Body: { pageNum: number, pageSize: number, ... }
  // Query: { adType?: number, positionType?: number, ... }
  getAdvertPage(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: `${infoFDUrl}/fd-activity/api/1/advert/page`,
      method: 'post',
      data: data.data,
      params: data.params,
      headers: {
        'Content-Type': 'application/json',
        ...data.headers,
      },
      sign: true
    })
  }
}
